import React from 'react'
import { useSelector } from 'react-redux'
import { InfoBlackSvg } from '../../asset/icon/InfoBlackSvg'
import { DistributeComponents } from '../../components/DistributeComponents/DistributeComponents'
import { LoaderConfig } from '../../components/LoaderConfig/LoaderConfig'
import { WrapModals } from '../../components/WrapModals/WrapModals'
import { IComponent } from '../../utils/type/dynamic-rendering.interfaces'
import { getCustomerInfoSetting, getCustomerInfoValue, getIsLoad, getKeySectionActive } from '../../store/selectors/selectors';
//@ts-ignore
import s from './CustomerInfo.module.scss'



export const CustomerInfo = ({ funcNextStep }: any) => {

    const stepInfo: any = useSelector(getCustomerInfoSetting);
    const isLoadData: any = useSelector(getIsLoad);
    const isCheckCustomerInfo: any = useSelector(getCustomerInfoValue);

    const keySectionActive = useSelector(getKeySectionActive);
    const settings: IComponent[] = stepInfo['setting'];

    let btnClassSvg = ``
    if (!isCheckCustomerInfo) btnClassSvg += ` ${s.disable}`

    return (<>
        {keySectionActive === 'CustomerInfo' && (
            <WrapModals>11123
                <div className={s.customInfo}>
                    <header>
                        <div className={s.title}>{stepInfo['name']}</div>
                        <InfoBlackSvg />
                    </header>

                    <main>
                        {settings.map((setting: IComponent) => {
                            return (<DistributeComponents key={setting['data']['id']} {...setting} />)
                        })}
                    </main>

                    <footer>
                        <button className={btnClassSvg} onClick={() => funcNextStep()}>build the shed</button>
                    </footer>
                </div>

                {isLoadData && (
                    <div className={s.loader_wrap}>
                        <div className={s.loader_main}>
                            <LoaderConfig />
                        </div>
                    </div>
                )}

            </WrapModals>
        )}


    </>
    )
}
